import { useEffect, useState } from "react";
import { DataDto, IPageProps } from "../../../Models";
import {
  Box,
  Button,
  FormControl,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import { AutoCompleteSelect } from "../../../Components";
import { AttributesService, UserControllerUrl } from "../../../Services";
import { Attribute } from "../../../Services/AttributesService";

const LogAppAttribute = (props: IPageProps) => {
  const [users, setUsers] = useState<DataDto[]>([]);
  const [attribute, setAttribute] = useState<Attribute>();
  const [id, setId] = useState<string>("");
  const [selectedUserId, setSelectedUserId] = useState<string>("");

  const service = new AttributesService();

  const handleSelectChange = (e: SelectChangeEvent<string>, userId: string) => {
    var attr = {
      id: userId,
      key: "IsDebuggable",
      value: e.target.value === "true",
    };
    setAttribute(attr);
  };

  const handleValueChanged = (value: DataDto | null) => {
    if (!value) {
      setAttribute(undefined);
      setSelectedUserId("");
      setId("");
    }
  };

  const updateIds = (newValue: string) => {
    setId(newValue);
  };

  const handleClick = async () => {
    await handleSubmit();
  };

  const handleSubmit = async () => {
    props.setIsLoading(true);

    if (!attribute) {
      props.setIsLoading(false);
      props.handleAlertShow("error", "Nessun utente selezionato");
      return;
    }
    
    try {
      await service.SaveAttribute(attribute);
      props.handleAlertShow("success", "L'operazione è andata a buon fine");
    } catch (error: any) {
      props.handleAlertShow("error", error.message);
    } finally {
      props.setIsLoading(false);
    }
  };

  const getData = async (type: string) => {
    props.setIsLoading(true);
    var data: DataDto[] = [];
    try {
      const response = await service.GetData(type);
      data = response.data;
    } catch (error: any) {
      props.handleAlertShow("error", error.message);
    } finally {
      props.setIsLoading(false);
    }
    return data;
  };

  useEffect(() => {
    const loadIsDebuggableData = async (userId: string) => {
      props.setIsLoading(true);
      try {
        const uri = `${UserControllerUrl}/GetUserAttributesWithValue/?textSearch=IsDebuggable&userId=${userId}`;

        var res: any = await service.GetAttributeByIdWithValue(uri);
        if (res.data) {
          setAttribute({
            id: userId,
            key: "IsDebuggable",
            value: res.data.value === "True",
          });
        } else {
          setAttribute({
            id: userId,
            key: "IsDebuggable",
            value: false,
          });
        }
      } catch (error: any) {
        props.handleAlertShow("error", error.message);
      } finally {
        props.setIsLoading(false);
      }
    };
    if (selectedUserId) {
      loadIsDebuggableData(selectedUserId);
    }
  }, [selectedUserId]);

  useEffect(() => {
    const loadData = async () => {
      var d: DataDto[] = [];

      if (users.length === 0) {
        d = await getData("AppUser");
        setUsers(d);
        return;
      }
    };
    loadData();
  }, []);

  return (
    <div>
      {props.isAdmin && (
        <FormGroup>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "65%", marginTop: "0.1rem" }}>
              <div>
                <div style={{ marginTop: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <AutoCompleteSelect
                      setParam={(val: string) => updateIds(val)}
                      handleAlertShow={props.handleAlertShow}
                      disabled={false}
                      label="AppUser"
                      styleToRender={{
                        width: "70%",
                        marginRight: "30px",
                      }}
                      data={users}
                      selectedData={(selected) =>
                        setSelectedUserId(selected.id)
                      }
                      onValueChange={(value) => {
                        handleValueChanged(value);
                      }}
                    />

                    {attribute && (
                      <div
                        style={{
                          marginLeft: "2.5rem",
                          marginRight: "2.5rem",
                        }}
                      >
                        <FormControl>
                          <InputLabel id="select-label">
                            IsDebuggable
                          </InputLabel>
                          <Select
                            labelId="select-label"
                            label="IsDebuggable"
                            sx={{ width: 200 }}
                            value={attribute.value === true ? "true" : "false"}
                            onChange={(e) =>
                              handleSelectChange(e, attribute.id)
                            }
                          >
                            <MenuItem value="true">True</MenuItem>
                            <MenuItem value="false">False</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    )}
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>

          <Box sx={{ p: "1rem" }}>
            <Button
              sx={{ width: 200, p: 1, mr: 2, float: "right" }}
              onClick={handleClick}
              variant="outlined"
            >
              Run
            </Button>
          </Box>
        </FormGroup>
      )}
    </div>
  );
};

export default LogAppAttribute;
